export default "__VITE_ASSET__Dw1yZEYx__"